/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: { truncateAbove: 6 }
    }
  ],
  tokens: {
    borderBottomWidth: 0,
    borderColor: '#676e73',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    color: '#676e73',
    ellipsisBorderBottomWidth: 0,
    ellipsisBorderLeftWidth: 0,
    ellipsisBorderRightWidth: 0,
    ellipsisBorderTopWidth: 0,
    ellipsisHeight: null,
    ellipsisPadding: 0,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    gap: 2,
    lineHeight: 1.5,
    truncateAbove: 4
  }
}
export default theme
